import { ExamLocationVerdict } from '@exam-center/graphql';
import { Flex, FormRadioSelection, FormTextField } from '@shared/components';

export default function ExamCenterLocationRequestVerdictFormField(
  { isReadOnly }: { isReadOnly: boolean } = { isReadOnly: false },
) {
  const verdictOptions = [
    { label: 'อนุมัติคำขอ', value: ExamLocationVerdict.Approved },
    { label: 'ไม่อนุมัติคำขอ', value: ExamLocationVerdict.Rejected },
  ];

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(6) }}>
      <FormRadioSelection
        name='verdict'
        label='ผลการอนุมัติคำขอ'
        options={verdictOptions}
        row
        required
        disabled={isReadOnly}
      />
      <FormTextField
        name='comment'
        label='ความคิดเห็นเพิ่มเติม'
        placeholder='ระบุความคิดเห็นเพิ่มเติม'
        multiline
        disabled={isReadOnly}
      />

      {/* TODO: จัดการสิทธิ์ใช้งานสถานที่ section */}
    </Flex>
  );
}
